export const XBOX_DEVICES = [
  // Original Xbox (2001)
  "X01-00001",
  "X01-00558", // Additional variations

  // Xbox 360 (2005)
  "X11-28500",
  "X11-82263", // Xbox 360 Core
  "X11-70568", // Xbox 360 Pro / Premium
  "X11-72155", // Xbox 360 Elite
  "X12-01726", // Xbox 360 Arcade
  "X12-25397", // Xbox 360 Slim (S)
  "X15-18343", // Xbox 360 E

  // Xbox One (2013)
  "1540", // Xbox One Original
  "1520", // Xbox One S
  "1787", // Xbox One X

  // Xbox Series (2020)
  "1882", // Xbox Series X
  "1883", // Xbox Series S
];
